import React, { useCallback, useState, useEffect } from "react";

import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Button,
  Modal,
  message,
} from "antd";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";

import {
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
  checkAlphabets,
  capitalise,
} from "../../../../utils";
import urls from "../../../../api/urls";
import moment from "moment";

import { APIs } from "../../../../utils/worker";
import API from "../../../../api";
const {
  VERIFY_PHONE_NUM,
  VERIFY_PHONE_OTP,
  SEND_SMS_PHONE,
  SEND_SMS_EMAIL,
  VERIFY_EMAIL_OTP,
} = urls;

function PersonalInputDetails({
  disableContinue,
  form,
  setDisableContinue,
  apiResponse,
}) {
  const date = new Date();
  const [modalForm] = Form.useForm();

  const result1 = moment(date).subtract(18, "years");

  const minDate = result1;

  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }

      return minDate != null && d.isAfter(minDate) && !d.isSame(minDate, "day");
    },
    [minDate]
  );

  let lg = 12;
  let sm = 12;
  let md = 12;
  let xs = 24;

  function validateInput(rule, value, callback) {
    if (/^\s/.test(value)) {
      callback("Input cannot start with a space!");
    } else {
      callback();
    }
  }

  const [showVerify, setShowVerify] = useState(false);
  const [visible, setVisible] = useState(false);

  const [otpValues, setOtpValues] = useState(null);
  console.log(otpValues);
  const [emailShowVerify, setEmailShowVerify] = useState(false);
  const [emailVisible, setEmailVisible] = useState(false);

  useEffect(() => {
    if (
      apiResponse?.premiseDto?.mobilePhone &&
      apiResponse?.premiseDto?.emailId
    ) {
      setShowVerify(false);
      setDisableContinue({
        otp1: false,
        otp2: false,
      });
    }
  }, [apiResponse]);

  const checkPhnNumExists = async (values) => {
    let response = await API.Api(VERIFY_PHONE_NUM).post({
      contactNumber: values,
    });
    if (response.status) {
      if (response.response.data === false) {
        message.error("Phone number already exists");
      } else {
        // sentPhoneOtp(values);
        setShowVerify(true);
      }
    }
    setShowVerify(true);
  };

  const checkEmailExists = (event) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (event.includes(".com" || ".COM" || ".in" || ".IN"))
    if (emailRegex.test(event)) {
      setEmailVisible(true);
    } else {
      setEmailVisible(false);
    }
  };

  const sentPhoneOtp = async () => {
    let phoneNum = form.getFieldValue("AlternateContacNo");

    let response = await API.Api(SEND_SMS_PHONE).post({
      mobileNo: phoneNum,
    });

    if (response.response.data === true) {
      message.info("OTP has sent the given number");
    } else {
      message.error("Failed to send the OTP");
    }
  };

  const sentEmailOtp = async () => {
    let email = form.getFieldValue("EmailId");

    let response = await API.Api(SEND_SMS_EMAIL).post({
      emailId: email,
    });

    if (response.response.data === true) {
      message.info("OTP has sent the given E-mail id");
    } else {
      message.error("Failed to send the OTP");
    }
  };

  const verifyPhoneOtp = async (values) => {
    let phoneNum = form.getFieldValue("AlternateContacNo");
    let response = await API.Api(VERIFY_PHONE_OTP).post({
      mobileNo: phoneNum,
      otp: values.otp,
    });

    if (response.response.data === true) {
      message.success("Phone number verified successfully");
      setDisableContinue({ ...disableContinue, otp1: false });
      // setPhnOtpVerified(true);
      modalForm.setFieldsValue({ otp: null });
      setVisible(false);
      setShowVerify(false);
    } else {
      message.error("Wrong OTP");
    }
  };
  const verifyEmailOtp = async (values) => {
    let email = form.getFieldValue("EmailId");
    let response = await API.Api(VERIFY_EMAIL_OTP).post({
      emailId: email,
      otp: values.otp,
    });

    if (response.response.data === true) {
      message.success("Email verified successfully");
      setDisableContinue({ ...disableContinue, otp2: false });
      modalForm.setFieldsValue({ otp: null });

      // setPhnOtpVerified(true);
      setEmailShowVerify(false);
      setEmailVisible(false);
    } else {
      message.error("Wrong OTP");
    }
  };

  const handleCloseModal = (params) => {
    modalForm.setFieldsValue({ otp: null });
    setVisible(false);
    setOtpValues(null);
  };

  return (
    <>
      <Modal
        title={null}
        open={visible}
        maskClosable={false}
        onCancel={handleCloseModal}
        width={400}
        loading={false}
        destroyOnClose
        className="staff-onboard-modal"
        footer={
          <>
            <div className="d-flex flex-end">
              <Button
                htmlType="submit"
                onClick={modalForm.submit}
                className="save-btn ml-1"
              >
                SUBMIT
              </Button>
            </div>
          </>
        }
      >
        <div>
          <Form
            form={modalForm}
            onFinish={verifyPhoneOtp}
            layout={"vertical"}
            className="global-form"
          >
            <Row
              justify=""
              span={24}
              className="global-form-row mt-2"
              gutter={20}
              style={{ padding: "0 30px" }}
            >
              <Col span={24}>
                <Form.Item
                  name="otp"
                  label="OTP"
                  rules={[
                    {
                      message: "OTP is required",
                      required: true,
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter OTP"
                    value={otpValues}
                    onChange={(e) => setOtpValues(e.target.value)}
                    maxLength={6}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <Modal
        title={null}
        open={emailShowVerify}
        maskClosable={false}
        destroyOnClose
        onCancel={() => {
          modalForm.setFieldsValue({ otp: null }),
            setEmailShowVerify(false),
            setOtpValues(null);
        }}
        width={400}
        loading={false}
        className="staff-onboard-modal"
        footer={
          <>
            <div className="d-flex flex-end">
              <Button
                htmlType="submit"
                onClick={modalForm.submit}
                className="save-btn ml-1"
              >
                SUBMIT
              </Button>
            </div>
          </>
        }
      >
        <div>
          <Form
            form={modalForm}
            onFinish={verifyEmailOtp}
            layout={"vertical"}
            className="global-form"
          >
            <Row
              justify=""
              span={24}
              className="global-form-row mt-2"
              gutter={20}
              style={{ padding: "0 30px" }}
            >
              <Col span={24}>
                <Form.Item
                  name="otp"
                  label="OTP"
                  rules={[
                    {
                      message: "OTP is required",
                      required: true,
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter OTP"
                    value={otpValues}
                    onChange={(e) => setOtpValues(e.target.value)}
                    maxLength={6}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <HeaderWithBottomLine
        text={"Proprietor / Personal details"}
        icon={false}
      />
      <Row gutter={40} className="basic-details-conten global-form-row">
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="Name"
            label={"Name"}
            rules={[
              {
                required: true,
                message: "Please enter name",
              },
              { validator: validateInput },

              // () => ({
              //   validator(rule, value = "") {
              //     if (value.substring(1, 0) === " ") {
              //       return Promise.reject("Invalid name ");
              //     } else {
              //       return Promise.resolve();
              //     }
              //   },
              // }),
            ]}
            onKeyPress={(event) => {
              if (checkAlphabets(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter name"
              type="text"
              maxLength={20}
              onBlur={(e) => form.setFieldValue("Name", capitalise(e))}
              // onInput={(e) => (e.target.value = firstLetterCapitalise(e))}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="cpInCharge"
            label={"CP office in-charge"}
            rules={[
              {
                required: true,
                message: "Please enter name",
              },
              { validator: validateInput },

              // () => ({
              //   validator(rule, value = "") {
              //     if (value.substring(1, 0) === " ") {
              //       return Promise.reject("Invalid name ");
              //     } else {
              //       return Promise.resolve();
              //     }
              //   },
              // }),
            ]}
            onKeyPress={(event) => {
              if (checkAlphabets(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter CP name"
              type="text"
              maxLength={20}
              onBlur={(e) => form.setFieldValue("cpInCharge", capitalise(e))}
              // onInput={(e) => (e.target.value = firstLetterCapitalise(e))}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="ContactNo"
            label={"Office number"}
            rules={[
              {
                required: true,
                message: "Please enter mobile number",
              },
              {
                pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                message: "Invalid mobile number",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input placeholder="Enter Contact no" maxLength={10} type="text" />
          </Form.Item>
        </Col>
        <Col lg={9} md={9} sm={9} xs={9}>
          <Form.Item
            name="AlternateContacNo"
            label={"Personal number"}
            rules={[
              {
                required: true,
                message: "Please enter mobile number",
              },
              {
                pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                message: "Invalid mobile number",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter alternate contact no"
              type="text"
              maxLength={10}
              onChange={(e) => {
                if (e.target.value.length === 10) {
                  checkPhnNumExists(e.target.value);
                } else {
                  // phnOtpVerified
                  // setPhnOtpVerified(false);
                  setShowVerify(false);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
          <Form.Item label={<span style={{ visibility: "hidden" }}>.</span>}>
            <Button
              className="btn-style cancel-btn"
              onClick={() => {
                setVisible(true);
                sentPhoneOtp();
              }}
              disabled={!showVerify}
            >
              VERIFY
            </Button>
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="Dob"
            label={"DOB"}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
            ]}
          >
            <DatePicker
              style={{
                width: "100%",
                background: "#f7f7f7",
                border: "none",
                borderRadius: "6px",
                height: "40px",
              }}
              size={"small"}
              format={"DD-MM-YYYY"}
              placeholder={"DD/MM/YYYY"}
              // disabledDate={disableDaysBeforeToday}
              // defaultPickerValue={minDate}
            />
          </Form.Item>
        </Col>
        <Col lg={9} md={9} sm={9} xs={9}>
          <Form.Item
            name="EmailId"
            label={"Office email id"}
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please enter E-mail!",
              },
            ]}
          >
            <Input
              placeholder="Enter email ID"
              type="text"
              onInput={(e) => checkEmailExists(e.target.value)}
            />
          </Form.Item>
        </Col>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
          <Form.Item label={<span style={{ visibility: "hidden" }}>.</span>}>
            <Button
              className="btn-style cancel-btn"
              onClick={() => {
                setEmailShowVerify(true);
                sentEmailOtp();
              }}
              disabled={!emailVisible}
            >
              VERIFY
            </Button>
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="EmailId2"
            label={"Personal email id"}
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please enter E-mail!",
              },
            ]}
          >
            <Input
              placeholder="Enter email ID"
              type="text"
              onInput={(e) => (e.target.value = e.target.value.toLowerCase())}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default PersonalInputDetails;
